import React, { useState } from 'react'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

interface SelectComponentProps {
  selectedDate: Date;
  handleDateChange: (date: Date) => void;
}

const CalendarSelectComponent: React.FC<SelectComponentProps> = ({selectedDate, handleDateChange}) => {
  return (
    <div className="relative">
      <DatePicker
        portalId="datepicker-portal"
        id="datepicker"
        selected={selectedDate}
        onChange={handleDateChange}
        className="px-3 py-2 w-36 text-sm font-medium rounded-lg
          bg-gray-100 dark:bg-dark-card text-gray-700 dark:text-gray-200
          border border-gray-300 dark:border-dark-border
          hover:border-gray-400 dark:hover:border-gray-500
          hover:bg-gray-50 dark:hover:bg-dark-card-hover
          focus:outline-none focus:ring-2 focus:ring-accent-teal/50 focus:border-accent-teal
          transition-all duration-200 ease-in-out cursor-pointer"
      />
    </div>
  );
}

export default CalendarSelectComponent
